import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import "../../assets/css/home.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Helmet } from "react-helmet";
import * as  CONST from "../../component/config/Constant"
import axios from "axios";
import parse from 'html-react-parser';
import Chatbot from '../../component/chatbot/Chatbot'
import { CHATBOT_HOME_QUERY } from "../../component/config/Constant";
import { FiArrowRight, FiMapPin, FiClock, FiUsers, FiChevronRight, FiExternalLink, FiLogIn, FiCalendar, FiFileText } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi";
import { BsQuote } from "react-icons/bs";

function Home() {

  const [policies, setPolicies] = useState("");
  const [webOpeningList, setwebOpeningList] = useState('');
  const [testimonials, setTestimonials] = useState("");
  const [testimonialsCount, setTestimonialsCount] = useState(0);
  const [events, setEvents] = useState("");


  useEffect(() => {
    fetchPolicyDetails();
    fetchWebOpeningsData();
    fetchTestimonials();
    fetchEventData();
  }, []);

  const [searchParam, setSearchParam] = useState(
    {
      "srchStatus": '1',
    }
  );

  const fetchTestimonials = async () => {
    await axios
      .get(CONST.TESTIMONIAL_LIST,
        {
          page_number: 1,
          limit: 10
        })
      .then((response) => {
        console.log('tESTIMONIALS-'+JSON.stringify(response.data.count));
        const status = response.data.status;
        if (status === 'success') {
          setTestimonials(response.data.data);
          setTestimonialsCount(response.data.count);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const fetchPolicyDetails = async () => {
    await axios
      .get(CONST.WEB_GET_POLICY_LIST,
        {
          page_number: 1,
          limit: 10
        })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          console.log(response.data.data);
          setPolicies(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function fetchWebOpeningsData() {
    const response = await axios
      .post(CONST.GET_OPENINGS_WEB_LIST, {
        'page_number': 1,
        'limit': 6,
      })
      .then((response) => {
        const status = response.data.status;
        if (status === 'success') {
          setwebOpeningList(response.data.data);
        }
      });
  }

  const fetchEventData = async (cat_id) => {

    await axios
      .post(CONST.WEB_GET_EVENTDATA,
        {
          "sort": {
            "order": "asc",
            "order_by": "id"
          },
          "page_number": 1,
          "limit": 6

        })

      .then((response) => {
        console.log("eventweb events: " + JSON.stringify(response.data))
        const status = response.data.status;
        if (status === 'success') {
          setEvents(response.data.data);
          console.log('web events=' + JSON.stringify(events));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const TestimonialOptions = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 3,
      },
      700: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  };
  const RedablePolicyOptions = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 3,
      },
      700: {
        items: 3,
      },
      1000: {
        items: 3,
      },
    },
  };

  function convertToSlug(Text) {
    return Text.toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, '-');
  }

  const capitalizeFirst = str => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };
  let policy_link = '';
  let policy_target_link = '';

  console.log(webOpeningList.length);

  return (
    <>
      <Helmet>
        <title>HRD Portal | eLuminous Technologies</title>
        <link rel="canonical" href="/" />
      </Helmet>

      {/* ===== HERO SECTION ===== */}
      <section className="hero-section-wrapper-1 hero-redesign hero-light">
        <div className="hero-section hero-style-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="hero-content-wrapper pt-5">
                  <span className="hero-badge">HR Portal</span>
                  <h1>
                    Your <span className="color_blue">HR Portal</span>,{" "}
                    All in One Place
                  </h1>
                  <h5 className="mt-3 mb-4">
                    Manage leaves, track holidays, access policies, and stay
                    connected with everything that matters at work.
                  </h5>
                  <div className="hero-buttons mt-4">
                    {localStorage.getItem("eToken") ? (
                      <>
                        <Link to="/admin/employee/leaves/my" className="btn hero-btn-primary">
                          <FiFileText style={{ marginRight: 8 }} /> Apply Leave <FiArrowRight style={{ marginLeft: 6 }} />
                        </Link>
                        <Link to="/admin/holiday" className="btn hero-btn-outline">
                          <FiCalendar style={{ marginRight: 8 }} /> View Holidays
                        </Link>
                      </>
                    ) : (
                      <>
                        <Link to="/login" className="btn hero-btn-primary">
                          <FiLogIn style={{ marginRight: 8 }} /> Login <FiArrowRight style={{ marginLeft: 6 }} />
                        </Link>
                        <Link to="/admin/holiday" className="btn hero-btn-outline">
                          <FiCalendar style={{ marginRight: 8 }} /> View Holidays
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-6 align-self-center">
                <div className="hero-image-wrapper">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/img/hero/hero-1/employee-hrd.svg"
                    }
                    alt="HR Portal"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Chatbot Query="CHATBOT_HOME_QUERY" />
      </section>

      {/* ===== OUR POLICIES SECTION ===== */}
      <section className="our_policy">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-5">
                <span className="section-tag">Company Guidelines</span>
                <h3 className="mb-2">Our Policies</h3>
                <p className="section-subtitle">Stay informed about company policies and guidelines</p>
              </div>
            </div>
          </div>
          <div className="row">
            {policies &&
              policies.map((policy, index) => {
                if (policy.e_policy_type.name == "Textual Policies") {
                  policy_link =
                    "/policy/" +
                    policy.id +
                    "/" +
                    convertToSlug(policy.policy_name);
                  policy_target_link = "";
                } else {
                  policy_link = CONST.HOST + policy.policy_document_path;
                  policy_target_link = "_blank";
                }
                return (
                  <div className="col-12 col-md-6 col-lg-4 mb-4" key={index}>
                    <div className="policy-card">
                      <div className="policy-icon">
                        <HiOutlineDocumentText />
                      </div>
                      <Link to={policy_link} target={policy_target_link} className="policy-link">
                        {policy.policy_name}
                        <FiChevronRight className="policy-arrow" />
                      </Link>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      {/* ===== CAREER SECTION (hidden) =====
      <section className="career careers container-fluid career-section-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-5">
                <span className="section-tag">Join Our Team</span>
                <h3 className="mb-2">Career Openings</h3>
                <p className="section-subtitle">Explore internal opportunities and grow your career</p>
              </div>
            </div>
          </div>
          <div className="row">
            {webOpeningList &&
              webOpeningList.map((element, key) => {
                return (
                  <React.Fragment key={key}>
                    {(() => {
                      if (element.status == "1") {
                        return (
                          <div className="col-md-12 col-lg-6 col-sm-12">
                            <Link
                              className="page-scroll"
                              to={"/openings-details/" + element.id}
                            >
                              <div className="career-card mb-4">
                                <div className="career-card-header">
                                  <span className="career-location">
                                    <FiMapPin size={14} />
                                    {capitalizeFirst(element.location)}
                                  </span>
                                  <span className="career-posted">
                                    <FiClock size={14} />
                                    {element.posted_at} days ago
                                  </span>
                                </div>
                                <div className="career-card-body">
                                  <h4 className="career-title">{element.title}</h4>
                                  <div className="career-progress-row">
                                    <div className="career-progress-wrapper">
                                      <div className="progress">
                                        <div
                                          className="progress-bar"
                                          role="progressbar"
                                          style={{
                                            width:
                                              (element.applied_count /
                                                element.total_openings) *
                                                100 +
                                              "%",
                                          }}
                                          aria-valuenow={element.applied_count}
                                          aria-valuemin="0"
                                          aria-valuemax={element.total_openings}
                                        ></div>
                                      </div>
                                      <span className="career-applied-text">
                                        <FiUsers size={14} />
                                        {element.applied_count} Applied
                                      </span>
                                    </div>
                                    <button className="btn career-apply-btn">
                                      Apply Now <FiArrowRight />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </div>
                        );
                      }
                    })()}
                  </React.Fragment>
                );
              })}
          </div>
          {(() => {
            if (webOpeningList.length > 1) {
              return (
                <div className="col-md-12">
                  <div className="row">
                    <div className="section-title text-center mt-4">
                      <Link to="/careers" className="btn btn-view-all">
                        View All Openings <FiArrowRight style={{ marginLeft: 6 }} />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            }
          })()}
        </div>
      </section>
      ===== END CAREER SECTION ===== */}

      {/* ===== TESTIMONIALS SECTION ===== */}
      <section className="testimonial-style-2 testimonials_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center mb-5">
                <span className="section-tag">Employee Voices</span>
                <h3 className="mb-2">Testimonials</h3>
                <p className="section-subtitle">What our team members think about us</p>
              </div>
            </div>
          </div>

          {testimonials && testimonialsCount > 0 ? (
            <div className="row">
              <OwlCarousel {...TestimonialOptions} id="testimonial">
                {testimonials.map((testimonial, index) => {
                  let testimonials_desc = testimonial.description.replace(
                    /(<([^>]+)>)/gi,
                    "",
                  );
                  testimonials_desc = testimonials_desc.replace(
                    "&nbsp;",
                    " ",
                  );
                  return (
                    <div className="item" key={index}>
                      <div className="testimonial-card">
                        <div className="testimonial-quote-icon">
                          <BsQuote />
                        </div>
                        <div className="testimonial-content">
                          <p>{testimonials_desc}</p>
                        </div>
                        <div className="testimonial-author">
                          <div className="testimonial-avatar">
                            {testimonial.user &&
                              (testimonial.user.profile_photo_path &&
                              testimonial.user.profile_photo_path ? (
                                <span className="avatar me-2">
                                  <img
                                    src={
                                      CONST.HOST +
                                      testimonial.user.profile_photo_path
                                    }
                                    alt=""
                                    width={48}
                                  />
                                </span>
                              ) : (
                                <span className="avatar me-2">
                                  <span>
                                    {testimonial.user.first_name &&
                                    testimonial.user.last_name ? (
                                      <>
                                        {testimonial.user.first_name &&
                                          testimonial.user.first_name.substring(0, 1)}
                                        {testimonial.user.last_name &&
                                          testimonial.user.last_name.substring(0, 1)}
                                      </>
                                    ) : (
                                      testimonial.user.name &&
                                      testimonial.user.name.substring(0, 2)
                                    )}
                                  </span>
                                </span>
                              ))}
                          </div>
                          <div className="testimonial-author-info">
                            <h6>
                              {testimonial.user && (
                                <>
                                  {testimonial.user.first_name}{" "}
                                  {testimonial.user.last_name}
                                </>
                              )}
                            </h6>
                            <p>
                              {testimonial.user &&
                                testimonial.user.department.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
          ) : (
            <div className="text-center text-muted">Testimonials not found!</div>
          )}
        </div>
      </section>

      {/* ===== EVENTS SECTION ===== */}
      <section id="gallery" className="event_section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="section-title text-center mb-5">
                <span className="section-tag section-tag-light">Life at eLuminous</span>
                <h3 className="mb-2">Events</h3>
                <p className="section-subtitle section-subtitle-light">Celebrating moments that bring us together</p>
              </div>
            </div>
          </div>
          <div className="grid_images">
            {events &&
              events.map((event, index) => {
                return (
                  <div className="event-card" key={index}>
                    {event.e_event_images &&
                      event.e_event_images.map((ele, eKey) => {
                        return ele.is_featured_image == 1 ? (
                          <div className="event-image" key={eKey}>
                            <img
                              src={CONST.HOST + ele.image_path}
                              className="img-fluid"
                              alt="Event"
                            />
                          </div>
                        ) : (
                          ""
                        );
                      })}
                    <div className="event-overlay">
                      <span className="event-link-icon">
                        <FiExternalLink />
                      </span>
                      <div className="event-overlay-content">
                        <h5>{event.title}</h5>
                        <div className="event-desc">
                          {parse(event.description.substring(0, 100))}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </>
  );
}
export default Home;
